import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { Button, Card, PageHeader } from '../components/ui';

export function Privacy() {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div style={{ padding: 'var(--space-4)', maxWidth: '800px', margin: '0 auto' }}>
        <PageHeader
          title="Privacy Policy"
          backButton={{ label: 'Back', onClick: () => navigate(-1) }}
        />

        <Card style={{ marginBottom: 'var(--space-6)', textAlign: 'center', padding: 'var(--space-8)' }}>
          <div style={{ marginBottom: 'var(--space-6)' }}>
            <span style={{ fontSize: '3rem' }}>🏗️</span>
          </div>
          <h2 style={{ margin: '0 0 var(--space-3) 0', color: 'var(--color-text-primary)' }}>
            Coming Soon
          </h2>
          <p style={{ margin: '0 0 var(--space-4) 0', color: 'var(--color-text-secondary)', lineHeight: 1.6 }}>
            We're currently drafting our Privacy Policy to ensure complete transparency about how we handle your campaign data and conversations.
          </p>
          <p style={{ margin: '0 0 var(--space-6) 0', color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)' }}>
            In the meantime, here's what we're committing to:
          </p>

          <div style={{ textAlign: 'left', marginBottom: 'var(--space-6)', backgroundColor: 'rgba(45, 226, 230, 0.05)', padding: 'var(--space-4)', borderRadius: 'var(--radius-sm)' }}>
            <ul style={{ margin: 0, paddingLeft: 'var(--space-5)', lineHeight: 1.8 }}>
              <li style={{ marginBottom: 'var(--space-2)' }}>
                <strong>Your conversations are stored</strong> — Campaign data and turns are saved in our database to let you resume your adventures.
              </li>
              <li style={{ marginBottom: 'var(--space-2)' }}>
                <strong>No third-party tracking</strong> — We don't sell your data or share it with advertisers.
              </li>
              <li style={{ marginBottom: 'var(--space-2)' }}>
                <strong>Minimal collection</strong> — We only store what's necessary to run the game and provide our service.
              </li>
              <li style={{ marginBottom: 'var(--space-2)' }}>
                <strong>Be mindful</strong> — Please don't share real personal information (addresses, phone numbers, etc.) in your campaign text.
              </li>
              <li>
                <strong>Your control</strong> — You can delete campaigns anytime. Deletion removes all associated data.
              </li>
            </ul>
          </div>

          <div style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-secondary)', marginBottom: 'var(--space-6)' }}>
            <p style={{ margin: 0, fontStyle: 'italic' }}>
              Full Privacy Policy coming before MVP v1 launch.
            </p>
          </div>

          <Button variant="primary" onClick={() => navigate('/campaigns')}>
            Back to Campaigns
          </Button>
        </Card>
      </div>
    </>
  );
}
